import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Mm10030View from "../../Views/Manufacture/MM10030";
import Snackbar from "../../Components/Snackbar";

function MM10030(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  //재출력 안 조회조건
  const [printInputs, setPrintInputs] = React.useState({
    value: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [stockData, setStockData] = React.useState([]);
  const [selectedModalData, setSelectedModalData] = React.useState(null);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  //조회
  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10030.GetWorkOrder,
        {
          startDate: new Date(startDate),
          endDate: endDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              woNo: data[i].woNo,
              workDt: data[i].workDt
                ? Commons.DateFormating(data[i].workDt.toString(), 2)
                : "",
              stusCd: data[i].stusCd,
              stusNm: data[i].stusNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              soDueDt: new Date(data[i].soDueDt),
              soDueNo: data[i].soDueNo,
              soNo: data[i].soNo,
              itemQty: data[i].itemQty,
              poStusNm: data[i].poStusNm,
              stockQty: data[i].stockQty,
              planQty: data[i].planQty,
              workQty: data[i].workQty,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SearchWorkLogic = async (_woNo, _itemCd) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let endDate = [];
    let startDate = [];
    let diffHour = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10030.GetWork,
        {
          woNo: _woNo,
          itemCd: _itemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            diffHour.push(new Date(data[i].wkEdDt) - new Date(data[i].wkStDt));
          }
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              wkSeq: data[i].wkSeq,
              processNm: data[i].processNm,
              workUser: data[i].workUser,
              processCd: data[i].processCd,
              // wkStDt: data[i].wkStDt.replace("T", " "),
              wkStDt: Commons.DateTimeChange(data[i].wkStDt),
              wkEdDt: data[i].wkEdDt
                ? Commons.DateTimeChange(data[i].wkEdDt)
                : "",
              wkDt: data[i].wkEdDt
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt,
                    data[i].wkEdDt
                  )
                : "[0:0]",
              seqQty: data[i].seqQty,
              seqFailQty:
                data[i].seqFailQty !== null ? data[i].seqFailQty : "0",
              seqQtyRate: data[i].seqQtyRate ? data[i].seqQtyRate + "%" : "0%",
              seqFailQtyRate: data[i].seqFailQtyRate
                ? data[i].seqFailQtyRate + "%"
                : "0%",
              machineNm: data[i].machineNm,
              endProcess: data[i].endProcess,
            });
          }
          setRowData1(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const DeleteConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (selectedRowData[0].stusNm == "출하지시") {
        for (let i = 0; i < rowData1.length; i++) {
          if (rowData1[i].endProcess == "최종/출력") {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "생산취소를 해주세요.",
            });
            return false;
          }
        }
      }
      if (selectedRowData[0].stusNm == "생산완료") {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "생산취소를 해주세요.",
        });
        return false;
      } else if (
        selectedRowData[0].stusNm == "출하" ||
        selectedRowData[0].stusNm == "납품"
      ) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "출하지시가 되었습니다.",
        });
        return false;
      } else {
        for (let i = 0; i < selectedRowData1.length; i++) {
          deleteData.push({
            woNo: selectedRowData[0].woNo,
            processCd: selectedRowData1[i].processCd,
            wkSeq: selectedRowData1[i].wkSeq,
            endProcess: selectedRowData1[i].endProcess,
            wkEdDt: Commons.DateStrChange(
              new Date(Commons.convertDateFormat(selectedRowData1[i].wkEdDt))
            ),
            createId: userInfo.userId,
            createDate: new Date(),
            updateId: userInfo.userId,
            updateDate: new Date(),
          });
        }
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Manufacture.MM10030.DeleteWork,
          deleteData
        ).then((result) => {
          let data = result.data;
          if (data !== "Ok") {
            setSnackbars({
              toggle: true,
              type: "error",
              message: data,
            });
          } else {
            // SearchLogic();
            SearchWorkLogic(selectedRowData[0].woNo, selectedRowData[0].itemCd);
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const WorkCancleConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        WorkCancle();
      }
    );
  };
  //생산취소
  const WorkCancle = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (
        selectedRowData[0].stusNm == "출하지시" ||
        selectedRowData[0].stusNm == "출하" ||
        selectedRowData[0].stusNm == "납품"
      ) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "출하지시가 되었습니다.",
        });
        return false;
      } else {
        for (let i = 0; i < selectedRowData.length; i++) {
          deleteData.push({
            woNo: selectedRowData[0].woNo,
            itemCd: selectedRowData[0].itemCd,
            soNo: selectedRowData[0].soNo,
            soDueDt: Commons.DateStrChange(selectedRowData[0].soDueDt),
            createId: userInfo.userId,
            createDate: new Date(),
            updateId: userInfo.userId,
            updateDate: new Date(),
          });
        }
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Manufacture.MM10030.WorkCancle,
          deleteData
        ).then((result) => {
          let data = result.data;
          if (data !== "Ok") {
            setSnackbars({
              toggle: true,
              type: "error",
              message: data,
            });
          } else {
            SearchLogic();
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const BarCodePrintConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Print" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Print" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        BarCodePrint();
      }
    );
  };
  //출력
  const BarCodePrint = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      if (
        selectedRowData1[0].endProcess == "중간출력" ||
        selectedRowData1[0].endProcess == "최종/출력"
      ) {
        for (let i = 0; i < selectedModalData.length; i++) {
          deleteData.push({
            itemCd: selectedModalData[i].itemCd,
            stockQty: selectedModalData[i].stockQty,
            whNm: selectedModalData[i].whNm,
            lotNo: selectedModalData[i].lotNo,
            updateId: userInfo.userId,
          });
        }
        await Commons.Axios(
          "post1",
          Global.serverUrls.useUrl +
            Global.urls.logic.Manufacture.MM10030.BarCodePrint,
          deleteData
        ).then((result) => {
          let data = result.data;
          if (data !== "Ok") {
            setSnackbars({
              toggle: true,
              type: "error",
              message: data,
            });
          } else {
            setSnackbars({
              toggle: true,
              type: "success",
              message: "출력되었습니다.",
            });
          }
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "출력할 제품이 없습니다.",
        });
        return false;
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //재출력안 조회
  const GetPrintStockData = async (_value, _whCd) => {
    Dialog.ProgressBar(true);
    let getData = [];
    let stockData = [];
    let userInfo;
    try {
      if (
        selectedRowData1.length == 0 ||
        selectedRowData1[0].endProcess == "종료" ||
        selectedRowData1[0].endProcess == "시작"
      ) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "출력할 공정을 선택하세요.",
        });
        return false;
      }
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (
        selectedRowData1[0].endProcess == "중간출력" ||
        selectedRowData1[0].endProcess == "최종/출력"
      ) {
        for (let i = 0; i < selectedRowData.length; i++) {
          stockData.push({
            woNo: selectedRowData[0].woNo,
            itemCd: selectedRowData[0].itemCd,
            wkEdDt: Commons.DateStrChange(
              new Date(Commons.convertDateFormat(selectedRowData1[0].wkEdDt))
            ),
            updateId: userInfo.userId,
          });
        }
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Manufacture.MM10030.GetPrintStockData,
          stockData
        ).then((result) => {
          let data = result.data;
          if (data === "데이터가 없습니다.") {
            setSnackbars({
              toggle: true,
              type: "error",
              message: data,
            });
            setStockData([]);
          } else {
            for (let i = 0; i < data.length; i++) {
              getData.push({
                lotNo: data[i].LotNo,
                itemNm: data[i].ItemCd,
                stockQty: data[i].StockQty,
                whNm: data[i].WhCd,
              });
            }
            getData = getData.filter((e) => e.stockQty > 0);
            setStockData(getData);
          }
        });
      }
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <>
      <Mm10030View
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        DeleteConfirm={DeleteConfirm}
        WorkCancleConfirm={WorkCancleConfirm}
        BarCodePrintConfirm={BarCodePrintConfirm}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        selectedRowData1={selectedRowData1}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        SearchWorkLogic={SearchWorkLogic}
        SearchLogic={SearchLogic}
        lanData={lanData}
        printInputs={printInputs}
        setPrintInputs={setPrintInputs}
        GetPrintStockData={GetPrintStockData}
        stockData={stockData}
        setStockData={setStockData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default MM10030;
